import * as React from 'react'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'

import OurMallsContent from '../../../../components/home/OurMallsContent/OurMallsContent'

import filterString from '../../../../services/data/filterString'

import * as MallApiService from '../../../../services/api/requests/Mall'

const Content = styled.div`
  padding: 20px;
`

class MainView extends React.Component {
  state = {
    currentMall: null,
  }

  componentWillMount() {
    const { waitRenderServer } = this.props

    waitRenderServer(true)

    this.getMallData()
  }

  getMallData = async () => {
    const { match, renderServer } = this.props
    const { viewId } = match.params

    try {
      const response = await MallApiService.getCMSMall(viewId)
      const mallInfo = response && response.data
      // setstate doesnt work on ssr
      this.setState({
        currentMall: mallInfo || null,
      })

      renderServer()
    } catch (e) {}
  }

  render() {
    const { currentMall } = this.state
    const { match } = this.props
    const { viewId } = match.params

    if (!currentMall) {
      return null
    }

    const contentUrl = `${process.env.REACT_APP_BASE_URL}/main/malls/${viewId}`

    return (
      <Content>
        <OurMallsContent data={currentMall} />
        <Helmet defaultTitle={currentMall.name}>
          <meta property="og:title" content={currentMall.name} />
          <meta
            property="og:description"
            content={filterString(currentMall.description)}
          />
          <meta
            property="og:image"
            content={currentMall.photos ? currentMall.photos[0].url : ''}
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={contentUrl} />
          <link rel="canonical" href={contentUrl} />
        </Helmet>
      </Content>
    )
  }
}

export default MainView
